module.exports = __webpack_public_path__ + "static/Magdy-fd8980c82b412642841ecbffca2e4c3a.png";